import { createContext, useContext, useState, useCallback, useRef } from "react";
import { api } from "@/lib/api";

const AdminContext = createContext({});

export function AdminProvider({ children }) {
    const [unread, setUnread] = useState(0);
    // Pages with unsaved changes set this to { save: async fn } so the layout
    // can warn (and offer to save) before navigating away. null = nothing to guard.
    const unsavedRef = useRef(null);

    const refreshUnread = useCallback(() => {
        api.get("/stats")
            .then((r) => setUnread(r.data?.unread_inquiries ?? 0))
            .catch(() => {});
    }, []);

    return (
        <AdminContext.Provider value={{ unread, setUnread, refreshUnread, unsavedRef }}>
            {children}
        </AdminContext.Provider>
    );
}

export const useAdmin = () => useContext(AdminContext);